import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IDatabaseContactParams {
    contactId: string;
    contactType: string;
    ids: string[];
}

export class SetDatabasesContactRequest extends Request<IDatabaseContactParams, IResult> {
    constructor(params: IDatabaseContactParams) {
      super('setDatabasesContact', params);
    }
  }
